/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Navigation_Audit_DetailInputs */



/**
* | output |
* | --- |
* | "An assessment of bridge-team management, procedures and passage planning, usually while the vessel is under way. We observe watchkeeping practice, review pla..." |
*
* @param {Service_Navigation_Audit_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_navigation_audit_detail = /** @type {((inputs?: Service_Navigation_Audit_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Navigation_Audit_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对驾驶台团队管理、程序和航线计划的评估，通常在船舶航行中进行。我们观察值班操作，审查计划和设备使用，并就航行安全出具报告。")
	return /** @type {LocalizedString} */ ("An assessment of bridge-team management, procedures and passage planning, usually while the vessel is under way. We observe watchkeeping practice, review planning and equipment use, and report on navigational safety.")
});